import { NavLink } from "react-router-dom";

const sections = [
  { to: "/admin/lessons", label: "Lesson Requests" },
  { to: "/admin/about", label: "About page", page: "about" },
  { to: "/admin/presskit", label: "Press Kit copy", page: "presskit" },
  { to: "/admin/media", label: "Media library" },
  { to: "/admin/media-kit", label: "Media Kit", page: "mediakit" },
];

export default function AdminLayout({ children, dirtyPages, email, onDismissStatus, onSignOut, status }) {
  return (
    <main className="admin-page">
      <header className="admin-topbar">
        <div className="admin-brand"><p className="admin-kicker">Website management</p><h1>Ken & Bryn Admin</h1></div>
        <div className="admin-account"><span>{email}</span><a href="/" target="_blank" rel="noopener noreferrer">View website</a><button type="button" onClick={onSignOut}>Sign out</button></div>
      </header>

      <div className="admin-dashboard">
        <aside className="admin-sidebar">
          <p>Manage</p>
          <nav className="admin-nav" aria-label="Admin navigation">
            {sections.map((section) => (
              <NavLink key={section.to} to={section.to} className={({ isActive }) => isActive ? "active" : undefined}>
                <span>{section.label}</span>
                {section.page && dirtyPages.has(section.page) && <span className="admin-dirty-dot" aria-label="Unsaved changes" />}
              </NavLink>
            ))}
          </nav>
        </aside>

        <section className="admin-workspace">
          {status.message && (
            <div className={`admin-message admin-global-message ${status.type}`} role={status.type === "error" ? "alert" : "status"} aria-live="polite">
              <span>{status.message}</span>
              <button type="button" onClick={onDismissStatus} aria-label="Dismiss message">×</button>
            </div>
          )}
          {children}
        </section>
      </div>
    </main>
  );
}
